import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { GlobalMetadataFactoryService } from '../../../services/global-metadata.factory.service';
import { MetadataFieldDataType } from '../../../../core/types';

@Component({
  selector: 'pixl-form-dialog-global-metadata-paired-selection',
  templateUrl: './form-dialog-global-metadata.paired-selection.component.html',
  imports: [
    CommonModule,
    MatFormField,
    ReactiveFormsModule,
    FormsModule,
    MatLabel,
    MatInput,
    MatButton,
    MatSelect,
    MatOption,
    MatIcon,
    MatIconButton
  ]
})
export class FormDialogGlobalMetadataPairedSelectionComponent {
  @Input() parentGroup!: FormGroup;

  cdr = inject(ChangeDetectorRef);

  private metaFactory = inject(GlobalMetadataFactoryService);

  // Options for datatype dropdown
  datatypeOptions = ['String', 'Int', 'Checkbox', 'ValueFromApiResult'];

  get options(): FormArray {
    return this.parentGroup.get('subFieldConf') as FormArray;
  }

  getSubFieldConf(group: FormGroup): FormArray {
    return group.get('subFieldConf') as FormArray;
  }

  getFormGroup(control: AbstractControl | null): FormGroup | null {
    return control && control instanceof FormGroup ? (control as FormGroup) : null;
  }

  addSubField(group: FormGroup, datatype: MetadataFieldDataType = 'String') {
    const newGroup: FormGroup = this.metaFactory.createFieldConfGroup({
      name: '',
      label: '',
      secondaryLabel: '',
      datatype,
      subFieldConf: [],
    });

    setTimeout(() => {
      this.getSubFieldConf(group).push(newGroup);
      this.cdr.detectChanges();
    }, 0);
  }

  removeSubField(array: FormArray, index: number) {
    array.removeAt(index);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getControls(formArray: any): AbstractControl[] {
    return formArray?.controls || [];
  }
}
